import * as THREE from 'three'

import MathsUtils from '@/utils/mathsUtils'
import IconObject from './iconObject'
import GlassDesignerTypes from '../types'


// Warning Icon Object
// Warning Icon used to display guideline warnings in the scene
// Managed by GuidelineHelper
export default class WarningIconObject extends IconObject {
  constructor(editor, options = {}) {
    super(editor, {
      iconTexture: editor.resources.iconWarningTexture
    })

    this.colour = options.colour || '#f8ac59'
    this.bgColour = options.bgColour || '#FFFFFF'
    this.ringColour = options.ringColour || '#606060'
    this.hoverColour = options.hoverColour || '#f8ac59'

    this.guidelineWarningId = options.warningId || ''
    this.warningTitle = options.warningTitle || ''
    this.warningHTMLDescription = options.warningHTMLDescription || ''
    this.warningFixAvailable = !!options.warningFixAvailable

    // Used by the guideline helper system
    this.isReleasedWarning = false
  }


  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

  }
}
